import { EventBus } from '@/app'

export default {
    data() {
        return {
            busyMessage: 'El carrito está ocupado',
            redirectAfterPayment: true,

            successResponseHandler: null,
            errorResponseHandler: null,

            busy: false,
            isCreated: false
        }
    },

    computed: {
        computedOrderId() {
            return _.get(this.$state, 'cart.id')
        },

        computedOrderToken() {
            return _.get(this.$state, 'cart.resource_token')
        }
    },

    methods: {
        //////////////////////////////////////////////////
        ///// General ////////////////////////////////////
        //////////////////////////////////////////////////

        beforeAction(success, error) {
            this.successResponseHandler = success
            this.errorResponseHandler = error

            if(this.busy) {
                this.busyCart()
            }
            
            this.setBusy()
        },

        setBusy() {
            this.$set(this, 'busy', true)
        },

        setFree() {
            this.$set(this, 'busy', false)
        },

        busyCart() {
            this.displayError(`Un momento por favor. ${this.busyMessage}`, 'Ups!', 'warning')
        },

        handleSuccess(cart, response, event) {
            this.$set(this.$state, 'cart', cart)

            EventBus.$emit('root', event, response)

            this.successResponseHandler(response)
        },

        handleError(response) {
            this.displayErrorFromResponse(response)

            this.setFree()

            this.content()
        },

        displayErrorFromResponse(response) {
            let message = null

            try {
                message = response.data.message
            } catch (error) {
                try {
                    message = Object.values(response.response.data.errors)[0][0]
                } catch (error) {
                    try {
                        message = response.message
                    } catch (error) {
                        message = 'Error desconocido'
                    }
                }
            }

            this.displayError(message, 'Error!', 'error')
        },

        displayError(message, title = 'Error!', type = 'error') {
            this.$alert(message, title, type)

            this.errorResponseHandler(message)
        },

        //  Evita el redireccionamiento después de crear/editar pedido
        noRedirect() {
            return this.setWithRedirect(false)
        },

        //  Asegura el redireccionamiento después de crear/editar pedido
        withRedirect() {
            return this.setWithRedirect(true)
        },

        setWithRedirect(redirectAfterPayment) {
            this.$set(this, 'redirectAfterPayment', redirectAfterPayment)

            return this
        },

        //////////////////////////////////////////////////
        ///// Order //////////////////////////////////////
        //////////////////////////////////////////////////

        async content() {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'get',
                    url: route('api.carts.content'),
                    params: {id: this.computedOrderId},
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.data,
                            'cart.obtained'
                        )
                    } else {
                        this.displayErrorFromResponse(response)
                    }
                })
                .catch(err => this.displayErrorFromResponse(err))
                .finally(() => this.setFree())
            })
        },

        async update() {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'put',
                    url: route('api.carts.update', this.$state.cart),
                    data: this.$state.cart,
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.data,
                            'cart.updated'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        async clean() {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'post',
                    url: route('api.carts.clean', this.$state.cart),
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.data,
                            'cart.cleaned'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        async destroy() {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'delete',
                    url: route('api.carts.destroy', this.$state.cart),
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.data,
                            'cart.destroyed'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        async process(data) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'post',
                    url: route('api.carts.process', this.$state.cart),
                    headers: {'resource-token': this.computedOrderToken},
                    data: data
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.data,
                            'cart.processed'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        //////////////////////////////////////////////////
        ///// Items //////////////////////////////////////
        //////////////////////////////////////////////////

        async addItem(item = {}) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                item.order_id = this.$state.cart.id

                axios({
                    method: 'post',
                    url: route('api.carts.add.item'),
                    data: item,
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.item,
                            'cart.item.added'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        async updateItem(item = {}) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'put',
                    url: route('api.carts.update.item', item),
                    data: item,
                    headers: {'resource-token': item.resource_token}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.item,
                            'cart.item.updated'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        async removeItem(item = {}) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'delete',
                    url: route('api.carts.remove.item', item),
                    headers: {'resource-token': item.resource_token}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.item,
                            'cart.item.removed'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        //////////////////////////////////////////////////
        ///// Invoice ////////////////////////////////////
        //////////////////////////////////////////////////

        async setInvoice(invoice = {}) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                invoice.invoiceable_type = this.$state.cart.class
                invoice.invoiceable_id = this.$state.cart.id

                axios({
                    method: 'post',
                    url: route('api.carts.set.invoice'),
                    data: invoice,
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.invoice,
                            'cart.invoice.setted'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        //////////////////////////////////////////////////
        ///// Quote //////////////////////////////////////
        //////////////////////////////////////////////////

        async getQuote(postcode_to) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                axios({
                    method: 'post',
                    url: route('api.carts.get.quote', this.computedOrderId),
                    data: {postcode_to: postcode_to},
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.quote,
                            'cart.quote.getted'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        //////////////////////////////////////////////////
        ///// Shipping ///////////////////////////////////
        //////////////////////////////////////////////////

        async setShipping(shipping = {}) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                shipping.order_id = this.$state.cart.id

                axios({
                    method: 'post',
                    url: route('api.carts.set.shipping'),
                    data: shipping,
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.shipping,
                            'cart.shipping.setted'
                        )
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        //////////////////////////////////////////////////
        ///// Payments ///////////////////////////////////
        //////////////////////////////////////////////////

        async addPayment(payment = {}) {
            if(this.$state.cart.processed) {
                return this.sendPayment(payment)
            }

            return this.process()
                .then(() => {
                    this.setFree()
                    return this.sendPayment(payment)
                })
        },

        async sendPayment(payment = {}) {
            return await new Promise((success, error) => {
                this.beforeAction(success, error)

                payment.payable_type = this.$state.cart.class
                payment.payable_id = this.$state.cart.id
                payment.amount = payment.amount ?? this.$state.cart.missing_amount
                payment.currency = 'MXN'

                axios({
                    method: 'post',
                    url: route('api.carts.add.payment'),
                    data: payment,
                    headers: {'resource-token': this.computedOrderToken}
                })
                .then(response => {
                    if(response.data.success) {
                        this.handleSuccess(
                            response.data.data,
                            response.data.payment,
                            'cart.payment.added'
                        )

                        if(this.redirectAfterPayment) {
                            window.location.href = _.get(response, 'data.payment.redirect_to')
                        }
                    } else {
                        this.handleError(response)
                    }
                })
                .catch(err => this.handleError(err))
                .finally(() => this.setFree())
            })
        },

        //////////////////////////////////////////////////
        ///// Regenerative observers /////////////////////
        //////////////////////////////////////////////////

        orderStatused(order) {
            if(order.id == this.$state.cart.id) {
                this.content()
            }
        },

        orderDestroyed(order) {
            if(order.id == this.$state.cart.id) {
                this.content()
            }
        },

        /*
        shippingStatused(shipping) {
            if(shipping.order_id == this.$state.cart.order_id) {
                this.content()
            }
        },
        */

        /*
        paymentAdded(payment) {
            if(payment.order_id == this.$state.cart.order_id) {
                this.content()
            }
        },
        */
    },

    created() {
        this.$set(this, 'isCreated', true)
    }
}